import { useEffect } from "react";
import { LOGO_URL } from "@/lib/constants";

const WA_LINK =
  "https://wa.me/96555787747?text=%D9%87%D9%84%D8%A7%20%D9%84%D9%82%D9%8A%D8%AA%D9%83%D9%85%20%D8%A8%D8%B3%D9%86%D8%A7%D8%A8%D8%8C%20%D8%A3%D8%A8%D9%8A%20%D8%B3%D8%B9%D8%B1%20%D9%84%D8%AA%D8%B5%D9%84%D9%8A%D8%AD%20%D8%B6%D8%B1%D8%A8%D8%A9";

const WhatsAppIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
  </svg>
);

export default function Snap() {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = "دنت إكسبرس — سعرك على الواتساب";
    let meta = document.querySelector('meta[name="robots"]');
    const created = !meta;
    if (created) {
      meta = document.createElement("meta");
      meta.name = "robots";
      document.head.appendChild(meta);
    }
    const prevRobots = meta.getAttribute("content");
    meta.setAttribute("content", "noindex, nofollow");
    return () => {
      document.title = prevTitle;
      if (created) document.head.removeChild(meta);
      else meta.setAttribute("content", prevRobots);
    };
  }, []);

  return (
    <main
      dir="rtl"
      lang="ar"
      data-testid="snap-page"
      className="min-h-[100dvh] bg-white flex flex-col items-center justify-center px-6 py-10 text-center"
      style={{ fontFamily: '"Tajawal", "IBM Plex Sans Arabic", sans-serif' }}
    >
      <img
        src={LOGO_URL}
        alt="دنت إكسبرس"
        data-testid="snap-logo"
        className="w-44 sm:w-52 h-auto"
      />
      <div className="mt-5 w-12 h-1 rounded-full bg-[#E8200A]" />

      <h1
        data-testid="snap-headline"
        className="mt-7 text-3xl sm:text-4xl font-black leading-tight text-[#1A1A1A]"
      >
        سعرك جاهز على{" "}
        <span className="text-[#E8200A]">الواتساب</span>
      </h1>
      <p data-testid="snap-subline" className="mt-3 text-sm sm:text-base text-[#1A1A1A]/70 max-w-xs sm:max-w-sm leading-relaxed">
        دز لنا صورة الضربة ونرد عليك بالسعر — من غير صبغ ولا حدادة
      </p>
      <p data-testid="snap-condition-line" className="mt-2 text-xs sm:text-sm text-[#1A1A1A]/45 max-w-xs sm:max-w-sm leading-relaxed">
        الشرط الوحيد: الصبغة سليمة — وإذا سليمة، نرجعها كأن شي ما صار
      </p>

      <a
        href={WA_LINK}
        target="_blank"
        rel="noreferrer"
        data-testid="snap-whatsapp-btn"
        className="mt-9 inline-flex items-center justify-center gap-3 w-full max-w-xs px-8 py-4 rounded-full bg-[#25D366] hover:bg-[#1fbd59] active:scale-[0.98] text-white text-xl font-bold shadow-xl shadow-emerald-600/30 transition"
      >
        <WhatsAppIcon className="w-6 h-6" />
        افتح الواتساب
      </a>

      <p data-testid="snap-trust-line" className="mt-8 text-xs text-[#1A1A1A]/50">
        الأولين بالكويت والشرق الأوسط من 2005 · الشويخ الصناعية
      </p>
    </main>
  );
}
